<template>
  <div class="header__filter">
    <div class="header__filter-item">
      <Dropdown
        :value="view.single_select_field"
        :disabled="readOnly"
        :show-search="true"
        class="extras-mg-kanban__selector"
        @input="cambiarCampo"
      >
        <DropdownItem name="Sin columnas" :value="null"></DropdownItem>
        <DropdownItem
          v-for="campo in camposDeSeleccion"
          :key="campo.id"
          :name="campo.name"
          :value="campo.id"
        ></DropdownItem>
      </Dropdown>
    </div>
  </div>
</template>

<script>
import Dropdown from '@baserow/modules/core/components/Dropdown'
import DropdownItem from '@baserow/modules/core/components/DropdownItem'
import { notifyIf } from '@baserow/modules/core/utils/error'

export default {
  name: 'KanbanViewHeader',
  components: { Dropdown, DropdownItem },
  props: {
    database: { type: Object, required: true },
    view: { type: Object, required: true },
    table: { type: Object, required: true },
    fields: { type: Array, required: true },
    readOnly: { type: Boolean, required: true },
    storePrefix: { type: String, required: false, default: '' },
  },
  computed: {
    camposDeSeleccion() {
      return this.fields.filter((f) => f.type === 'single_select')
    },
  },
  methods: {
    async cambiarCampo(idCampo) {
      try {
        await this.$store.dispatch('view/update', {
          view: this.view,
          values: { single_select_field: idCampo },
        })
      } catch (e) {
        notifyIf(e, 'view')
      }
    },
  },
}
</script>
